
import { defineComponent, reactive } from "vue";
import { useRouter } from "vue-router";
import { Rate } from "vant";
import { getUserInfo } from "@/api/userApi";
import { getMyPointLst } from "@/api/UserPointsApi";

export default defineComponent({
    setup() {
        const router = useRouter();

        const state = reactive({
            list: [],
            loading: true,
            finished: false,
            refreshing: false,
            index: 0,
        });

        return {
            state,
            router, //一定要要放在return里才能在模板上面使用
        };
    },

    mounted() {
        // this.rePage();
        this.getUserInfo();
    },
    methods: {
        async getUserInfo() {
            this.userInfo = await getUserInfo();
            this.rate = this.userInfo.level;
            this.currentPoint = this.userInfo.myPoints;
        },
        async loadData({ index, setData }) {
            var datainfo = await getMyPointLst(index, this.pageSize);
            const arr =  datainfo.rows;
            setData(arr, datainfo.total);
        },
    },
    name: "GyMyPoints",
    components: { [Rate.name]: Rate },
    data() {
        return {
            // 星星，积分等级
            rate: 0,
            currentPoint: 0,
            userInfo: {},
            pageSize: 20,
            dataTotalCount: 0,
        };
    },
});
